<template>
  <div id="app">
    <identity-authenticate  
      v-if="!fileListLoaded"
      :on-authenticated="onAuthenticated" />
    <file-list v-if="identityAuthenticated" :platform="platform"  />
    <file-renderer />
    <file-viewer :platform="platform" style="position: absolute; z-index: 9999" />
    <input type="file" ref="file_picker" @change="event => filePickerChanged(event)" style="display: none;" multiple/>
  </div>
</template>

<script>
import FileList from '@/pages/FileList.vue'
import FileRenderer from '@/pages/FileRenderer.vue'
import FileViewer from '@/pages/FileViewer.vue'
import IdentityAuthenticate from '@/pages/IdentityAuthenticate.vue'
import { ApplicationContext } from '@/utils/context';

export default {
  name: 'App',
  components: {
    FileList, 
    FileRenderer,
    FileViewer,
    IdentityAuthenticate
  },
  data() {
    return {
      identityAuthenticated: false,
      fileListLoaded: false,
      platform: 'unknown'
    };
  },
  methods: {
    detectPlatform() {
      const ua = navigator.userAgent || window.opera;
      if (ua.indexOf("Windows NT") !== -1) {
          this.platform = "windows";
      } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
          if ((ua.includes('safari') || ua.includes('Safari')) && !ua.includes('chrome') && !ua.includes('Chrome')) {
            this.platform =  "ios safari";
          } else {
            this.platform =  "ios";
          }
      } else if (ua.indexOf("HarmonyOS") !== -1 || ua.indexOf("HUAWEI") !== -1) {
          this.platform =  "HarmonyOS";
      } else if (/android/i.test(ua)) {
          this.platform =  "android";
      }
    },
    onAuthenticated() {
      this.identityAuthenticated = true;
      let loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      ApplicationContext.$on('on_loaded_file_list', () => {
        this.fileListLoaded = true;
        loading.close();
        ApplicationContext.$off('on_loaded_file_list');
      });
    },
    filePickerChanged(event) {
      if (event.target.files && 0 < event.target.files.length) {
        ApplicationContext.$emit('finish_picking_file', event.target.files);
      }
    }
  },
  mounted() {
    this.detectPlatform();
    window.addEventListener("resize", this.detectPlatform);
    ApplicationContext.$on('do_picking_file', () => {
      this.$refs.file_picker.click();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.detectPlatform);
    ApplicationContext.$off('do_picking_file');
    ApplicationContext.$off('on_loaded_file_list');
  },
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard syntax */
  text-align: center;
  color: #2c3e50;
}
html, body {
  margin: 0;
  height: 100vh;
  overflow: hidden; /* 防止页面滚动引起的问题 */
}
.el-card__body {
  width: 100% !important;
  height: 100% !important;
  padding: 20px 0px !important;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard syntax */
  cursor: pointer;
}
.el-card__body:active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #f5f7fa; /* 点击时变色 */
}
/* 覆盖 el-dialog 的默认样式 */
.el-message-box {
  position: absolute;
  top: calc(50%) !important; /* 确保垂直居中 */
  width: 90% !important;
  max-width: 430px !important;
  transform: translateY(-50%) !important; /* 使用 translate 实现垂直居中 */
}

/* 避免设备上的样式冲突 */
.el-message-box__wrapper {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  position: fixed; /* 确保在视口中固定 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000; /* 覆盖可能的层级问题 */
}
.el-loading-mask {
  z-index: 999999 !important;
}
.el-icon-loading {
  font-size: 128px; /* 根据需要设置图标的大小 */
}
.vue-office-pdf-wrapper{
  overflow-y: scroll;
}
.viewer-container {
  z-index: 99999 !important;
}
.docx {
  background: white !important;
  border: white !important;
  --docx-dk2-color: white !important;
  --docx-lt2-color: white !important;
}
article {
  background: white !important;
  border: white !important;
}
</style>
